import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class ExploitAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'exploit';

	getCombo() {
		let request = {
			url: [this.getAPIUrl(), 'combo'].join('/'),
		};

		return httpClient.getAsync(request);
	}
}

export default new ExploitAPI();
